import { render, staticRenderFns } from "./work-view.vue?vue&type=template&id=fef486dc&scoped=true&"
import script from "./work-view.vue?vue&type=script&lang=js&"
export * from "./work-view.vue?vue&type=script&lang=js&"
import style0 from "./work-view.vue?vue&type=style&index=0&id=fef486dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef486dc",
  null
  
)

export default component.exports